"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sprintf = sprintf;
exports.createTranslate = createTranslate;

var _sprintfJs = require("sprintf-js");

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sprintf(str) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  try {
    return _sprintfJs.sprintf.apply(void 0, __spreadArrays([str], args));
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('i18n', e);
    } // return string if sprintf failed
    // It is better to display unformatted string than break js at all


    return str;
  }
}

function createTranslate(messages) {
  var T = function T(key) {
    if (key === void 0) {
      key = '';
    }

    var rest = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    }

    return sprintf.apply(void 0, __spreadArrays([messages[key] || key], rest));
  };

  return {
    T: T
  };
}